// Generated for @nava/participant-copy: Clair's default texts in Portuguese. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Portuguese. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_PT = {
    'landing.changeLanguage': 'Mudar idioma',
    'common.language': 'Idioma',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Podes falar com a Clair em mais de 80 idiomas.',
    'common.seeLanguages': 'Ver quais',
    'footer.poweredBy': 'Com tecnologia de',
    'landing.heading': 'Recebeste um convite para uma breve conversa.',
    'landing.intro': 'A empresa {company} gostaria de saber como estão a correr as coisas para ti. Vais falar com a Clair, uma assistente de IA, quando te der jeito.',
    'landing.continue': 'Continuar',
    'preflight.title': 'Precisamos apenas de algumas coisas',
    'preflight.checkInSubtitle': 'Completa a lista abaixo para começar a conversa.',
    'preflight.actions.expandItem': 'Expandir {{item}}',
    'preflight.microphone.title': 'Acesso ao microfone',
    'preflight.microphone.checkInPrivacy': 'A tua voz é usada para a conversa com a Clair, uma assistente de IA. A conversa é gravada, transcrita e partilhada com {company}. Todos os dados são encriptados e armazenados em segurança.',
    'preflight.microphone.readMore': 'Leia mais',
    'preflight.microphone.grantAccess': 'Conceder acesso',
    'preflight.microphone.indicatorAction': 'Conceder acesso ao microfone',
    'preflight.microphone.accessGranted': 'Acesso concedido',
    'preflight.microphone.errorHelper': 'Verifique as configurações do seu navegador e tente novamente.',
    'preflight.microphone.browserNotSupported': 'Seu navegador não suporta gravação de áudio. Por favor, use Chrome, Firefox ou Safari.',
    'preflight.terms.title': 'Privacidade e consentimento',
    'preflight.terms.checkInPrivacy': 'Esta conversa é conduzida pela Clair, uma assistente de IA, em nome de {company}. As tuas respostas são partilhadas com {company} e nunca são usadas para publicidade. Podes parar a qualquer momento.',
    'preflight.terms.readMore': 'Leia mais',
    'preflight.terms.accept': 'Sim, eu aceito',
    'preflight.terms.indicatorAction': 'Aceitar privacidade e consentimento',
    'preflight.terms.accepted': 'Aceito',
    'preflight.terms.rememberConsent': 'Guardar o meu consentimento durante 30 dias',
    'preflight.terms.rememberConsentCallTooltip': 'O consentimento é guardado apenas para esta chamada, neste navegador, durante 30 dias.',
    'quickStart.agree': 'Aceitar',
    'quickStart.back': 'Voltar',
    'quickStart.cancel': 'Cancelar',
    'preflight.startCheckIn': 'Começar a conversa',
    'preflight.preparingCheckIn': 'A preparar a conversa...',
    'preflight.preparingCheckInDelayedTitle': 'A preparar a conversa.',
    'preflight.preparingCheckInDelayedSubtitle': 'Ainda estamos a trabalhar, aguarda um momento.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Isto está a demorar mais do que o esperado.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Pedimos-te um pouco de paciência.',
    'preflight.checkInPreparationFailedTitle': 'Não foi possível preparar a conversa',
    'preflight.checkInPreparationFailedMessage': 'Não foi possível carregar alguns ficheiros da conversa. Verifica a tua ligação e tenta novamente.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': 'Conectando',
    'interview.status.speaking': 'A falar',
    'interview.status.listening': 'A ouvir',
    'interview.status.thinking': 'A pensar',
    'interview.question': 'Pergunta {{current}} de {{total}}',
    'interview.mainQuestion': 'Pergunta principal {{current}} de {{total}}',
    'interview.recording': 'Sua resposta está sendo gravada...',
    'interview.endInterview': 'Terminar a conversa',
    'interview.muteTooltip': 'Silenciar microfone',
    'interview.unmuteTooltip': 'Ativar microfone',
    'interview.pauseTooltip': 'Fazer uma pausa',
    'interview.resumeTooltip': 'Retomar a conversa',
    'interview.subtitleTooltip.show': 'Mostrar legendas (CC)',
    'interview.subtitleTooltip.hide': 'Ocultar legendas (CC)',
    'interview.toggleChat': 'Escrever em vez disso',
    'interview.toggleVoice': 'Falar em vez disso',
    'interview.chatTooltip.type': 'Digite sua resposta em vez disso',
    'interview.chatTooltip.speak': 'Fale sua resposta em vez disso',
    'interview.chatTooltip.unavailable': 'Disponível quando conectado',
    'interview.chatDiscoveryHint': 'Não consegue falar? Toque para escrever',
    'interview.chatPlaceholder': 'Digite sua mensagem...',
    'interview.sendMessage': 'Enviar',
    'interview.chat.warmHeader': 'Leva o teu tempo, eu espero enquanto escreves',
    'interview.chat.newlineHint': 'Shift + Enter para nova linha',
    'interview.chat.aiVoiceOn': 'Voz ativada',
    'interview.chat.aiVoiceOff': 'Voz silenciada',
    'interview.chat.backToVoice': 'Voltar à voz',
    'interview.audio.controls': 'Definições de áudio',
    'interview.audio.callVolume': 'Volume da chamada',
    'interview.audio.muteSpeaker': 'Silenciar o altifalante',
    'interview.audio.unmuteSpeaker': 'Ativar o altifalante',
    'interview.audio.microphone': 'Microfone',
    'interview.audio.speaker': 'Altifalante',
    'interview.audio.device': 'Dispositivo de áudio',
    'interview.audio.linkedRouting': 'O teu telemóvel controla o microfone e o altifalante em conjunto.',
    'interview.audio.phoneSpeaker': 'Altifalante do telemóvel',
    'interview.audio.phoneEarpiece': 'Auscultador do telemóvel',
    'interview.audio.bluetoothHeadset': 'Auriculares Bluetooth',
    'interview.audio.wiredHeadset': 'Auriculares com fio',
    'interview.audio.usbAudio': 'Áudio USB',
    'interview.audio.systemDefault': 'Predefinição do sistema',
    'interview.audio.changeFailed': 'Não foi possível mudar o dispositivo de áudio.',
    'interview.networkQuality.excellent': 'A qualidade da rede é excelente.',
    'interview.networkQuality.good': 'A qualidade da rede é boa.',
    'interview.networkQuality.poor': 'A qualidade da rede é fraca.',
    'interview.networkQuality.bad': 'A qualidade da rede é muito fraca.',
    'interview.networkQuality.offline': 'A ligação está offline.',
    'interview.pauseModal.title': 'Conversa em pausa',
    'interview.pauseModal.timeRemaining': '{{time}} restantes',
    'interview.pauseModal.timeoutWarning': 'Se ficares em pausa, a conversa termina sozinha em breve.',
    'interview.pauseModal.resume': 'Retomar a conversa',
    'interview.pauseModal.end': 'Terminar a conversa',
    'interview.endConfirm.title': 'Terminar a conversa?',
    'interview.endConfirm.body': 'Não poderá voltar após terminar. O seu progresso até agora será guardado.',
    'interview.endConfirm.cancel': 'Continuar a conversa',
    'interview.endConfirm.end': 'Terminar a conversa',
    'complete.checkInTitle': 'Obrigado pelo teu tempo',
    'complete.checkInMessage': 'As tuas respostas vão para a equipa {company}.',
    'studyClosed.checkInTitle': 'Esta conversa está fechada',
    'studyClosed.checkInMessage': 'Obrigado pelo teu interesse, já não aceita respostas.',
    'studyNotOpen.checkInTitle': 'Esta conversa ainda não está aberta',
    'studyNotOpen.checkInMessage': 'Tenta abrir o link novamente mais tarde.',
    'studyNotReady.checkInTitle': 'Esta conversa está quase pronta',
    'studyNotReady.checkInMessage': 'Tenta abrir o link novamente dentro de alguns minutos.',
    'participantLinkCompleted.checkInTitle': 'Já tiveste esta conversa',
    'participantLinkCompleted.checkInMessage': 'Obrigado pelo teu tempo, não precisas de fazer mais nada.',
    'loading.interview': 'A carregar a conversa...',
    'browserHelp.title': 'Abra no seu navegador',
    'browserHelp.description': 'O navegador integrado desta aplicação pode restringir o acesso ao microfone. Abra a ligação no {{browserOptions}} para uma melhor experiência.',
    'browserHelp.namedDescription': 'O navegador integrado de {{app}} pode restringir o acesso ao microfone. Abra a ligação no {{browserOptions}} para uma melhor experiência.',
    'browserHelp.appleBrowsers': 'Safari ou no Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge ou no Chrome',
    'browserHelp.otherBrowsers': 'Chrome ou noutro navegador',
    'browserHelp.openSafari': 'Abrir no Safari',
    'browserHelp.copyLink': 'Copiar ligação',
    'browserHelp.copied': 'Ligação copiada. Cole-a no seu navegador.',
    'browserHelp.manualCopy': 'Não foi possível copiar automaticamente. Selecione e copie a ligação abaixo.',
    'browserHelp.copyInstructions': 'Copie a ligação abaixo e cole-a noutro navegador. Também pode procurar no menu da aplicação uma opção para abrir esta página no seu navegador predefinido.',
    'browserHelp.linkLabel': 'Link da conversa',
    'browserHelp.continueAnyway': 'Continuar mesmo assim',
    'preflight.microphone.recovery.denied': 'Acesso ao microfone negado.',
    'preflight.microphone.recovery.timedOut': 'O pedido de acesso ao microfone demorou demasiado. Verifique se o navegador apresenta um pedido de permissão e tente novamente.',
    'preflight.microphone.recovery.notFound': 'Não foi encontrado nenhum microfone. Liga um microfone e tenta novamente.',
    'preflight.microphone.recovery.notReadable': 'Não foi possível ativar o microfone. Fecha outras aplicações que o estejam a usar e tenta novamente.',
    'preflight.microphone.recovery.failed': 'Não conseguimos aceder ao microfone. Verifica o microfone e tenta novamente.',
    'preflight.microphone.recovery.retry': 'Tentar novamente',
    'preflight.microphone.recovery.close': 'Fechar',
    'preflight.microphone.recovery.helpTitle': 'Permitir o acesso ao microfone',
    'preflight.microphone.recovery.helpDescription': 'O acesso ao microfone continua bloqueado. O navegador pode ter guardado a tua escolha anterior e não voltar a pedir autorização.',
    'preflight.microphone.recovery.safariMacSettings': 'Na barra de menus do Safari, selecione Safari > Definições > Sites > Microfone. Procure este site na lista.',
    'preflight.microphone.recovery.chromiumSettings': 'Clique no ícone de controlos do site à esquerda da barra de endereço e selecione Definições do site > Microfone.',
    'preflight.microphone.recovery.siteSettings': 'Abre as permissões deste site através do ícone ou menu junto à barra de endereços, ou nas definições de sites do navegador.',
    'preflight.microphone.recovery.allowMicrophone': 'Permite o acesso ao microfone para este site, volta aqui e seleciona «Tentar novamente». Se o navegador pedir para recarregar a página, fá-lo.',
    'preflight.microphone.recovery.deviceSettings': 'Se o acesso já estiver permitido, verifica nas definições do dispositivo se este navegador pode usar o microfone.',
    'microphoneQuality.title': 'Qualidade do microfone',
    'microphoneQuality.instructions': 'Fale por alguns segundos para que possamos verificar o quão bem conseguimos te ouvir.',
    'microphoneQuality.recoveryMessage': 'Não conseguimos ouvir-te. Se estiveres numa chamada, termina-a primeiro. Fecha outras aplicações que estejam a usar o microfone e tenta novamente.',
    'microphoneQuality.poor': 'Ruim',
    'microphoneQuality.almostThere': 'Quase lá',
    'microphoneQuality.perfect': 'Perfeito!',
    'microphoneQuality.waiting': 'Aguardando áudio...',
    'microphoneQuality.from': 'De',
    'microphoneQuality.defaultDevice': 'Microfone padrão',
    'microphoneQuality.helpText': 'Por favor fale mais alto ou aproxime-se do microfone',
    'microphoneQuality.done': 'Pronto',
    'startupRecovery.title': 'Não foi possível iniciar a conversa',
    'startupRecovery.failed': 'Não conseguimos ligar ao serviço de conversa. Tenta novamente.',
    'startupRecovery.timedOut': 'A ligação demorou demasiado tempo. Tente novamente.',
    'startupRecovery.cancelled': 'A ligação foi cancelada. Pode tentar novamente quando estiver pronto.',
    'startupRecovery.microphone': 'Não foi possível aceder ao microfone. Verifique as permissões e tente novamente.',
    'startupRecovery.delayed': 'Ainda a estabelecer ligação. Está a demorar mais do que o habitual…',
    'startupRecovery.retry': 'Tentar novamente',
    'startupRecovery.support': 'Referência de suporte',
    'startupRecovery.copy': 'Copiar referência',
    'startupRecovery.copied': 'Copiada',
    'startupRecovery.checking': 'A verificar a ligação…',
    'startupRecovery.unavailable': 'Não foi possível verificar',
    'startupRecovery.advice': 'Esta verificação testa apenas a acessibilidade. Pode tentar iniciar na mesma. Se não funcionar, experimente outro navegador ou outra rede.',
    'startupRecovery.checkAgain': 'Verificar novamente a ligação...',
    'connectionDetails.quality': 'Qualidade da rede',
    'connectionDetails.excellent': 'Excelente',
    'connectionDetails.good': 'Boa',
    'connectionDetails.poor': 'Fraca',
    'connectionDetails.bad': 'Má',
    'connectionDetails.offline': 'Sem ligação',
    'connectionDetails.notChecked': 'Não verificado',
    'connectionDetails.lastChecked': 'Última verificação',
    'connectionDetails.warning': 'Não foi possível verificar a ligação: {{services}}.',
    'connectionDetails.navaApi': 'API da Clair',
    'connectionDetails.interviewApi': 'Serviço de conversa da Clair',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Atualizar teste de ligação',
    'connectionDetails.success': 'Verificação de ligação concluída com sucesso.',
    'connection.error': 'Erro de ligação',
    'connection.errorDefault': 'Não foi possível ligar ao serviço de conversa',
    'connection.retry': 'Tentar novamente',
    'versionRefresh.message': 'Há uma nova versão disponível. Atualize o navegador quando for conveniente.',
    'versionRefresh.action': 'Atualizar',
    'cookies.banner.title': 'Valorizamos sua privacidade',
    'cookies.banner.message': 'Usamos cookies para otimizar sua experiência, entender o uso do produto e apoiar um marketing relevante. Escolha <bold>“Aceitar tudo”</bold> para consentir com todos os cookies ou <bold>“Gerenciar preferências”</bold> para ajustar suas configurações.',
    'cookies.banner.privacyPolicy': 'Política de Privacidade',
    'cookies.banner.acceptAll': 'Aceitar tudo',
    'cookies.banner.managePreferences': 'Gerenciar preferências',
    'cookies.modal.title': 'Configurações de cookies',
    'cookies.modal.description': 'Quando visitas a Clair, podemos guardar ou obter dados sobre ti através de cookies e tecnologias semelhantes. Os cookies essenciais mantêm o site a funcionar. Podes alterar as preferências opcionais a qualquer momento.',
    'cookies.modal.readMore': 'Leia mais em nossa',
    'cookies.modal.save': 'Salvar',
    'cookies.modal.close': 'Fechar preferências de cookies',
    'cookies.modal.essential.title': 'Essenciais',
    'cookies.modal.essential.description': 'Necessários para a funcionalidade básica do site. Os cookies essenciais não podem ser desativados.',
    'cookies.modal.analytics.title': 'Análises',
    'cookies.modal.analytics.description': 'Ajuda a Clair a perceber como o site funciona, como os visitantes o usam e se pode haver problemas técnicos.',
    'invitation.subject': 'Uma breve conversa com a empresa {company}',
    'invitation.greeting': 'Olá {name},',
    'invitation.body': 'Gostaríamos de saber como estão a correr as coisas para ti.',
    'invitation.aiNotice': 'Vais falar com a Clair, a nossa assistente de IA. A maioria das pessoas acha mais fácil ser sincera com uma IA do que com uma pessoa. Podes conversar quando te der jeito, no trabalho ou em casa.',
    'invitation.button': 'Começar a conversa',
    'invitation.fallbackLink': 'Ou cola este link no teu navegador:',
    'invitation.footer': 'Recebes esta mensagem porque és cliente da empresa {company}. A conversa é conduzida pela Clair, uma assistente de IA, em nome da empresa.',
    'invitation.optOut': 'Não me enviar mais estas mensagens',
    'sms.invite': 'A empresa {company} convida-te para uma breve conversa:',
    'sms.stop': 'Cancelar SMS:',
};
//# sourceMappingURL=pt.js.map